package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.Universe
import fr.manyverse.app.domain.repository.UniverseRepository

class GetUniversesUseCase(private val universeRepository: UniverseRepository) {
    suspend operator fun invoke(userId: String): Result<List<Universe>> {
        return universeRepository.getCustomUniversesForUser(userId)
    }
}
